<template>
  <div class="container-fluid">
    <div class="row">
      <div v-if="can('my_service')" class="col-12">
        <div class="d_flex_btwn">
          <h5 class="common_subtitle pb_20  font_16p pt_20">My Service </h5>
        </div>

        <cloud-table-component
            :columns="columns"
            :rows="inquiries"
            :sortable="sortable"
            :pagination="pagination"
            @sorting="sorting"
            @pageChanged="pageChanged">

            <template v-slot:status="{ row }">
                <span v-if="row.status == 'processing'" class="color_warning">Processing</span>
                <span v-if="row.status == 'running'" class="color_success">Running</span>
                <span v-if="row.status == 'stopped'" class="color_danger">Stopped</span>
            </template>

            <template v-slot:kt_platform="{ row }">
              <span v-if="row.kt_platform == 'g'" class="color_success">G</span>
              <span v-if="row.kt_platform == 'd'" class="color_warning">D</span>
            </template>

            <template v-slot:specification="{ row }">
              <span v-if="row.kt_platform == 'g'">{{ row?.serverProductType?.service_offering_desc }}</span>
              <span v-if="row.kt_platform == 'd'">{{ row?.serverDProductType?.name }}</span>
            </template>

            <template v-slot:os_desc="{ row }">
              <span v-if="row.kt_platform == 'g'">{{ row?.serverProductType?.template_desc }}</span>
              <span v-if="row.kt_platform == 'd'">{{ row?.serverDProductType?.catChildList?.display_name }}</span>
            </template>

        </cloud-table-component>
      </div>
      <div v-else class="p-3">
        <p>You do not have permission to view this content.</p>
      </div>
    </div>

  </div>
</template>

<script>
import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import {useAbility} from "@casl/vue";

export default {
  name: "MyService",
  components: {CloudTableComponent},
  data() {
    return {
      inquiries: [],
      filter: {
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'server_name,cloudService.name,serverRegion.name,os_name,status',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "Server Name",
          field: "server_name",
        },
        {
          label: "Service Provider",
          field: "cloudService.name",
        },
        {
          label: "Region",
          field: "serverRegion.name",
        },
        {
          label: "Kt platform",
          field: "kt_platform",
          sortable: true,
          slot: true,
        },
        {
          label: "OS",
          field: "os_desc",
          sortable: false,
          slot: true,
        },
        {
          label: "Specification",
          field: "specification",
          sortable: false,
          slot: true,
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
          slot: true,
        },
      ],
      pagination: null,
      isShowInquiryModal: false,
      editId: null,
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.getMyInquiry()
      }
    },
  },
  mounted() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.getMyInquiry()
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        server_region_id: query.server_region_id,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {
        server_region_id: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'server_name,cloudService.name,serverRegion.name,os_name,status',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    getMyInquiry() {
      this.lyLoading = true
      this.axios.get('/my-services', {
        params: { ...this.queryParams, ...this.filter }
      })
          .then(({data}) => {
            this.inquiries = data.data
            this.pagination = data.meta;
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    openModal(editId = null){
      this.editId = editId
      this.isShowInquiryModal = true;
    },
    closeModal(){
      this.isShowInquiryModal = false;
    },
  },
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
}
</script>

<style scoped>

</style>